import React from "react";
import { COLORS } from "../../theme";

// Spinner simples via @keyframes num <style> de verdade — igual ao @media print
// em AppLayout.js, a prop `style` não tem como expressar animação.
export default function Spinner({ size = 16, color = COLORS.primary }) {
  return (
    <>
      <style>{`
        @keyframes pz-spin { to { transform: rotate(360deg); } }
      `}</style>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        style={{ animation: "pz-spin 0.7s linear infinite" }}
      >
        <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2.5" opacity="0.2" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    </>
  );
}
